import React, { lazy } from 'react';
import logo from "../../common/media/cc_logo_grey.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import TogetherForTheFutureSection from "./sections/TogetherForTheFutureSection";
import QuotesSection from "./sections/QuotesSection";
import ProjectsSection from "./sections/ProjectsSection";
import FAQSection from "./sections/FAQSection";
import FooterSection from "./sections/FooterSection";


const LandingPage = ({ merchantCode, fetchedImpact, projects, lang }) => {

    const ImpactSectionLazy = lazy(() => import('./sections/ImpactSection'));
    const TogetherForTheFutureSectionLazy = lazy(() => import('./sections/TogetherForTheFutureSection'));
    const QuotesSectionLazy = lazy(() => import('./sections/QuotesSection'));
    const ProjectsSectionLazy = lazy(() => import('./sections/ProjectsSection'));
    const FAQSectionLazy = lazy(() => import('./sections/FAQSection'));
    const FooterSectionLazy = lazy(() => import('./sections/FooterSection'));

    return (
        <div>
            <div className="mobile-hide h-100px w-100 bg-white h-align px-5">
                <img height='50px' src="https://res.cloudinary.com/carbonclick/image/upload/v1686818432/Enterprise/Etihad/etihad-airways-logo-wo-cw_p2gbva.svg" />
            </div>
            <div className="h-85vh px-5 w-100 position-relative hero-img header-img-cover vertical-align-parent" >
                <div className="color-white text-align-start vertical-align">
                    <div className="mobile-hide">
                        <h1 className="color-secondary mb-4 text-shadow mt-0 etihad-bold">Become a <br/>sustainable traveller</h1>
                        <h5 className="color-secondary mb-4 text-shadow font-etihad">Reduce your environmental impact</h5>
                        <div className="mobile-hide mb-4">
                            <div className="d-flex gap-8" style={{ alignItems: 'baseline' }}>
                                <a className="button-transformation no-color-btn btn-primary font-etihad" href="#FlightCalculator">Offset my flight</a>
                                <div className='powered-by d-flex'>
                                    <h5 className="color-secondary margin-inline-end-2 m-0 font-etihad">Powered by</h5>
                                    <div>
                                        <a target="_blank" href="https://www.carbonclick.com/">
                                            <img style={{ height: 24 }} src={logo} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <h2 className="color-secondary mb-4 text-shadow mt-0 font-etihad font-bold header-text">Become a sustainable traveller</h2>
                        <a className="button-transformation no-color-btn font-bold font-etihad btn-primary" href="#FlightCalculatorDummy">Offset my flight</a>
                    </div>
                </div>

                <div className='arrow-container fade-in'>
                    <a href="#content">
                        <img width='60px' height='50px' src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,c_scale,h_50,w_60/e_colorize,co_white/v1661168019/Enterprise/Etihad/down-arrow_dtvbk5.png' />
                    </a>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-main-light p-3 text-center">
                    <div className="d-flex w-fit center powered-by-container">
                        <h5 className="color-secondary margin-inline-end-2 font-bold m-0 font-etihad">Powered by</h5>
                        <div>
                        <a target="_blank" href="https://www.carbonclick.com/">
                            <img style={{ height: 26 }} src={logo} />
                        </a>
                        </div>
                    </div>
                </div>
            </div>

            <React.Suspense fallback={<div/>}>
                <ImpactSectionLazy fetchedImpact={fetchedImpact}/>
            </React.Suspense>

            <div className="bg-white pattern-1 py-5 img-contain" id="FlightCalculator" style={{backgroundRepeat: "no-repeat", backgroundPosition: "left"}}>
                <div className="container mobile-p-0">
                    <div className="center shadow-lg flight-calculator-wrapper">
                        <div id="FlightCalculatorDummy"/>
                        <FlightCalculator merchantCode={merchantCode} />
                    </div>
                </div>
            </div>

            <React.Suspense fallback={<div/>}>
                <TogetherForTheFutureSectionLazy/>
            </React.Suspense>


            <React.Suspense fallback={<div/>}>
                <QuotesSectionLazy/>
            </React.Suspense>


            <React.Suspense fallback={<div/>}>
                <ProjectsSectionLazy projects={projects} lang={lang} />
            </React.Suspense>


            <React.Suspense fallback={<div/>}>
                <FAQSectionLazy/>
            </React.Suspense>


            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}

            <React.Suspense fallback={<div/>}>
                <FooterSectionLazy/>
            </React.Suspense>
        </div>
    )
}


export default LandingPage;